import TributeCard from "./TributeCard.jsx";

export default function TributeWall({ tributes, onCardClick, newIds }) {
  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "12px 20px 40px" }}>
      {tributes.length === 0 ? (
        <div style={{ textAlign: "center", padding: "48px 20px", color: "#AAA" }}>
          <p style={{ fontSize: "15px" }}>Be the first to submit a tribute!</p>
        </div>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "16px",
        }}>
          {tributes.map(function(t, i) {
            return (
              <TributeCard
                key={t.id}
                tribute={t}
                index={i}
                onCardClick={onCardClick}
                isNew={newIds && newIds.has(t.id)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
